import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CONFIG = {
  404: {
    code: "404",
    title: "Página não encontrada",
    description: "A página que você procura não existe ou foi movida.",
  },
  403: {
    code: "403",
    title: "Acesso negado",
    description: "Você não tem permissão para acessar este recurso.",
  },
  500: {
    code: "500",
    title: "Erro interno",
    description: "Algo deu errado no servidor. Tente novamente em instantes.",
  },
} as const;

type ErrorCode = keyof typeof CONFIG;

export function ErrorPage({ code = 404 }: { code?: ErrorCode }) {
  const navigate = useNavigate();
  const { title, description } = CONFIG[code];

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
      <p className="text-7xl font-bold text-muted-foreground/30">{code}</p>
      <h1 className="mt-4 text-2xl font-semibold text-foreground">{title}</h1>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">{description}</p>
      <div className="mt-8 flex gap-3">
        <Button onClick={() => navigate("/dashboard")}>Ir para o dashboard</Button>
        <Button variant="outline" onClick={() => navigate(-1)}>
          Voltar
        </Button>
      </div>
    </div>
  );
}
